import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { EventsService } from '../events-service/events.service';

interface AuthorizeNetCardData {
	cardNumber: string;
	month: string;
	year: string;
	cardCode: string;
	zip: string;
	fullName: string;
}

declare const Accept;

@Injectable({
	providedIn: 'root'
})
export class AuthorizeNetService {

	constructor(
		private http: HttpClient,
		private eventService: EventsService
	) { }

	getAuthnetNonce(cardData: AuthorizeNetCardData) {
		cardData.cardNumber = cardData.cardNumber.replace(/-/g, '');

		const authData: {clientKey: string, apiLoginID: string} = this.getAuthData();

		const secureData = {authData, cardData};

		return Observable.create((observer) => {
			Accept.dispatchData(secureData, (response) => {
				if (response.messages.resultCode === 'Error') {
					observer.error(response.messages.message);
				} else {
					observer.next(response.opaqueData);
				}
				observer.complete();
			});
		});
	}

	executePayment(eventId, entity, entityId, nonce) {
		return this.http.post(`/api/v1/events/${eventId}/${entity}/${entityId}/authnet-execute`, {
			opaqueData: nonce
		});
	}

	getAuthData() {
		return {
			clientKey: this.eventService.eventData.processors.authorize_net.client_key,
			apiLoginID: this.eventService.eventData.processors.authorize_net.login_id,
		};
	}
}
